<template>
  <div class="container">
    <h1>Purchase access</h1>
    <p>
      Any person may gain access to all or parts of the Index, including scorecards, annotations, CTC Compliance Watchlist notices, unlimited complimentary 'certified-for-transaction' (CFT) scorecards, and data-graphing capabilities, per the following non-transferable subscription options:
    </p>
    <div class="columns">
      <div class="column flex-column">
        <div>
          <h2>Enhanced subscription</h2>
          <p>Access equal to that of an AWG charter member, including unlimited complimentary CFT scorecards</p>
          <p>$20,000 per annum</p>
        </div>
        <button class="button is-primary" :disabled="!EnhancedSubscriptionId" @click="$router.push({name: 'checkout', params: { productId: EnhancedSubscriptionId, updatesRole: true }})">Purchase</button>
      </div>
      <div class="column flex-column">
        <div>
          <h2>Standard subscription</h2>
          <p>Access to all materials other than complimentary CFT scorecards, annotations, and data-graphing</p>
          <p>$10,000 per annum</p>
        </div>
        <button class="button is-primary" :disabled="!StandardSubscriptionId" @click="$router.push({name: 'checkout', params: { productId: StandardSubscriptionId, updatesRole: true }})">Purchase</button>
      </div>
      <div class="column flex-column">
        <div>
          <h2>Per-country subscription</h2>
          <p>Access to all materials related to a country, including annotations and data-graphing but excluding complimentary CFT scorecards. You may purchase multiple per-country subscriptions.</p>
          <p>$2,000 per country per annum</p>
        </div>
        <b-field label="">
          <b-select v-model="country.groupId" placeholder="Select a Country">
            <option v-for="opt in options.countries" :value="opt.Id" :key="opt.Id">{{opt.Name}}</option>
          </b-select>
        </b-field>
        <button class="button is-primary" :disabled="!country.groupId || !PerCountrySubscriptionId" @click="$router.push({name: 'checkout', params: { productId: PerCountrySubscriptionId, updatesRole: true, groupId: country.groupId }})">Purchase</button>
      </div>
    </div>
    <p>To view a video tutorial demonstrating how to purchase access to proprietary information, please <router-link to="/purchasingAccess">click here</router-link>.</p>
    <p class="breathe"><router-link to="/login">Go to login page</router-link></p>
  </div>
</template>

<script>
  export default {
    name: "restricted",
    data() {
      return {
        options: {
          countries: [],
          products: []
        },
        country: {
          groupId: null
        }
      }
    },
    computed: {
      PerCountrySubscriptionId() {
        if (this.options.products.length > 0) {
          var products = this.options.products
            .filter(p => p.Name.includes("Per-Country Subscription"))
            .map(p => p.Id);
          if (products.length == 1)
            return products[0];
          else
            return null;
        }
        else
          return null;
      },
      StandardSubscriptionId() {
        if (this.options.products.length > 0) {
          var products = this.options.products
            .filter(p => p.Name.includes("Standard Membership"))
            .map(p => p.Id);
          if (products.length == 1)
            return products[0];
          else
            return null;
        }
        else
          return null;
      },
      EnhancedSubscriptionId() {
        if (this.options.products.length > 0) {
          var products = this.options.products
            .filter(p => p.Name.includes("Enhanced Membership"))
            .map(p => p.Id);
          if (products.length == 1)
            return products[0];
          else
            return null;
        }
        else
          return null;
      }
    },
    methods: {
      GetOptions() {
        this.$http.get("api/group/countries").then(resp => {
          this.options.countries = resp.data;
        })
      },
      GetProducts() {
        this.$http.get("api/product/quicklist").then(resp => {
          this.options.products = resp.data;
        })
      }
    },
    created() {
      this.GetOptions();
      this.GetProducts();
    }
  }
</script>
